import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=0dacd1be&scoped=true&"
import script from "./Application.vue?vue&type=script&setup=true&lang=js&"
export * from "./Application.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dacd1be",
  null
  
)

export default component.exports